import type { GlobalFilter } from '@hotjar/global-filters';
import { FilterKindEnum } from '@hotjar/global-filters';
import { StatefulFilterChain } from '@hotjar/webapp/features/GlobalFilterChain/StatefulComponent/StatefulFilterChain';
import { ProductType } from '@hotjar/global-filters/src/domains/global-filters/model/Product';
import type { KnownReferrer } from '@hotjar/webapp/features/Billing/PlanComparisonModal/types';
import { useSubscription } from '@hotjar/webapp/hooks/useSubscription';
import { useCallback } from 'react';
import { useSurveyFilters } from '@hotjar/feedback/hooks/useSurveyFilters';

const SUPPORTED_FILTER_LIST: Set<FilterKindEnum> = new Set([
  FilterKindEnum.Country,
  FilterKindEnum.UserAttribute,
  FilterKindEnum.DeviceType,
]);

export const SurveyResponseFilterChain = (): JSX.Element => {
  const { globalFilters, setGlobalFilters } = useSurveyFilters();

  const onFilterChange = useCallback(
    (newGlobalFilter: GlobalFilter) => {
      setGlobalFilters(newGlobalFilter);
    },
    [setGlobalFilters],
  );

  const { upsell } = useSubscription();

  const onUpsellRequest = useCallback(
    (_featureName: string, kind: string | undefined) => {
      // Feature SHOULD match a known referrer - upsell currently checks this and throws if it doesn't match
      upsell(`survey.filters.${kind}` as KnownReferrer);
    },
    [upsell],
  );

  return (
    <StatefulFilterChain
      currentFiltersInUiFormat={globalFilters}
      onChange={onFilterChange}
      supportedFilterList={SUPPORTED_FILTER_LIST}
      onUpsellRequest={onUpsellRequest}
      hideAllDateOption={false}
      hideSaveSegment
      contextOfUse={{
        productType: ProductType.Feedback,
        page: 'surveys.responses',
        toolName: 'Surveys',
      }}
    />
  );
};
